import { useState } from "react";
import UsersContext from "../context/usersContext";
import User from "../../entities/User";

const UserProvider = ({ children }) => {
  //llocal state
  const [users, setUsers] = useState([]);

  //methods
  const getUsers = (data) => {
    const usersFormated = data.map((user) => new User(user));
    setUsers(usersFormated);
  };

  //value context
  const contextValue = {
    users,
    getUsers,
  };

  return (
    <UsersContext.Provider value={contextValue}>
      {children}
    </UsersContext.Provider>
  );
};

export default UserProvider;
